// extracted by mini-css-extract-plugin
export var width100 = "t_s d_s";
export var design3Pos = "t_q0 d_X";